// extracted by mini-css-extract-plugin
export var logo = "_ce-2";
export var logoWrapper = "_ce-1";
export var strip = "_ce-0";